(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbCardDialogController', TkbCardDialogController);

    TkbCardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TkbCard', 'Customer'];

    function TkbCardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TkbCard, Customer) {
        var vm = this;

        vm.tkbCard = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tkbCard.id !== null) {
                TkbCard.update(vm.tkbCard, onSaveSuccess, onSaveError);
            } else {
                TkbCard.save(vm.tkbCard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:tkbCardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
